import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, SxProps } from '@mui/material';
import { theme } from '../../../../../../common/styles/theme';

export const ASIDE_WIDTH = 380;

export const Aside = ({
    children,
    className = '',
    sx,
    onClose,
}: {
    children: JSX.Element | JSX.Element[];
    className?: string;
    sx?: SxProps;
    onClose?: () => void;
}) => (
    <Stack
        className={`call-aside ${className}`}
        component={'aside'}
        justifyContent={'space-between'}
        sx={{
            ...sx,
            position: 'relative',
            flexShrink: 0,
            flexGrow: 0,
            width: `${ASIDE_WIDTH}px`,
            height: 1,
            color: theme.palette.grey[700],
            background: theme.palette.common.white,
            borderRadius: theme.spacing(.75),
        }}
    >
        {children}
    </Stack>
);

Aside.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onClose: PropTypes.func,
};
